@if (table.name && table.dates?.length) {
  <div class="chart-table">
    <table>
      <caption>
        <div class="flex-row">
          @if (colorIndicator) {
            <i class="material-icons color-indicator-margin" [style.color]="colorIndicator">circle</i>
          }
          <span class="table-name">{{ 'missing.name' | translate }}: {{ table.name }}</span>
          @if ((labTintingMode === VectorHistoryService.LAB_TINTING_MODE_MASTER) && tintingTheoryAvg && tintingOffsetAvg) {
            <mat-icon
              class="cursor-pointer offset-icon"
              matTooltip="Th tinting step with offset"
              [matTooltipPosition]="'above'"
              (click)="showOffsetAvgClicked()">
              visibility
            </mat-icon>
          }
          @if ((labTintingMode === VectorHistoryService.LAB_TINTING_MODE_BATCH
            && (selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH || selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS))
            && tintingTheoryAvg && selectedCarbAvg) {
            <mat-icon
              class="cursor-pointer offset-icon"
              matTooltip="Th tinting step with CARB"
              [matTooltipPosition]="'above'"
              (click)="showCarbAvgClicked()">
              visibility
            </mat-icon>
          }
        </div>
        <span class="table-measurements">
          #{{ 'missing.measurements' | translate }}: <b>{{ table.measurements }}</b></span
          >
          <span class="table-dates">{{ table.dates[0] | date: 'dd.MM.y' }} - {{ table.dates[1] | date: 'dd.MM.y' }}</span>
        </caption>
        <thead>
          <th></th>
          @for (typeLabel of typeLabels; track typeLabel; let i = $index) {
            <th>
              <span>{{ typeLabel | labelByChartType: tolerance }}</span>
            </th>
          }
        </thead>
        <tbody>
          @for (row of tableData; track i; let i = $index) {
            <tr>
              @if (selectedAngles[i]) {
                <th class="is-left">
                  <span>{{ angles[i] }}°</span>
                </th>
                @for (col of row; track j; let j = $index) {
                  <td class="{{ 'text-' | kpiLabel: tableColors[i][j] }}">
                    <span [ngClass]="{ 'bold-text': tableHighlights[i][j] }">
                      {{ col | number: '1.2-2' }}
                    </span>
                  </td>
                }
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (table.nameCorresponding && table.datesCorresponding?.length) {
    <div class="chart-table">
      <table>
        <caption>
          <span class="table-name">{{ 'missing.name' | translate }}: {{ table.nameCorresponding }}</span>
          <span class="table-measurements">
            #{{ 'missing.measurements' | translate }}: <b>{{ table.measurementsCorresponding }}</b></span
            >
            <span class="table-dates">
              {{ table.datesCorresponding[0] | date: 'dd.MM.y' }} - {{ table.datesCorresponding[1] | date: 'dd.MM.y' }}</span
              >
            </caption>
            <thead>
              <th></th>
              @for (typeLabel of typeLabels; track typeLabel; let i = $index) {
                <th>
                  <span>{{ typeLabel | labelByChartType: tolerance }}</span>
                </th>
              }
            </thead>
            <tbody>
              @for (row of correspondingTableData; track i; let i = $index) {
                <tr>
                  @if (selectedAngles[i]) {
                    <th class="is-left">
                      <span>{{ angles[i] }}°</span>
                    </th>
                    @for (col of row; track j; let j = $index) {
                      <td class="{{ 'text-' | kpiLabel: correspondingTableColors[i][j] }}">
                        <span [ngClass]="{ 'bold-text': correspondingTableHighlights[i][j] }">
                          {{ col | number: '1.2-2' }}
                        </span>
                      </td>
                    }
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
